import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=8909cc08&scoped=true&"
import script from "./DesktopNav.vue?vue&type=script&lang=ts&"
export * from "./DesktopNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8909cc08",
  null
  
)

export default component.exports